<button type="button" class="btn btn-sm btn-danger fas fa-power-off" (click)="authService.logout()"></button>